import '../styles/QRScan.css'
import { Html5Qrcode } from 'html5-qrcode';
import React, { useEffect, useState } from 'react'
import API from '../APIs/AdminApi';
import LiquidSelector from '../Blocks/LiquidSelector';
import LiqSelArr from '../Blocks/LiqSelArr';
import LiquidButton from '../Blocks/LiquidButton';

const QRScan = ({adminData}) => {

  const [isEnabled, setEnabled] = useState(false)
  const [qrMessage, setQrMessage] = useState('')

  const [events, setEvents] = useState([]) // Изменено на пустой массив
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [scanedMemberData, setScanedMemberData] = useState(null)
  const [statusScan, setStatusScan] = useState(null)

  useEffect(() => {
    if(events.length === 0){
      API.LoadEvents().then(data => {
        if(data.status === 200){ // Исправлено с data.res на data.status
          setEvents(data.res.data.filter(event => event.status != 'eventClosed'))
        }
      }).catch(e => console.error(e))
    }
  }, [])

  useEffect(() => {
    const config = { fps: 10, qrbox: { width: 200, height: 200 } };
    const html5QrCode = new Html5Qrcode("qrCodeContainer")

    const qrScanerStop = () => {
      if (html5QrCode && html5QrCode.isScanning) {
        html5QrCode.stop().then(() => {
          console.log("Scanner stopped");
        }).catch((error) => {
          console.log("Scanner stop error:", error);
        })
      }
    }

    const qrCodeSuccess = (decodedText) => {
      setQrMessage(decodedText);
      // Здесь можно добавить обработку отсканированных данных
      console.log("Scanned data:", decodedText);
    }

    if (isEnabled) {
      html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccess)
        .then(() => {
          setQrMessage('')
        })
        .catch(error => {
          console.error("Scanner start error:", error);
          alert(`Ошибка запуска сканера: ${error.message}`);
          setEnabled(false);
        })
    } else {
      qrScanerStop()
    }

    return () => {
      qrScanerStop()
    }
  }, [isEnabled])

  useEffect(() => {
    if(qrMessage == '') return
    API.ScanQR(adminData, qrMessage).then(data => {
      if(data.status == 200){
        setScanedMemberData(data.res.data)
        setStatusScan(data.res.meta)
      }
    }).catch(e => {
      setStatusScan(e.response.data.meta)
      setScanedMemberData(null)
      console.error(e)}
    )

  }, [qrMessage])

  return (
    <section className='qrScanerSection'>
      <div>
        <h2 className='qrNameText'>Сканер QR-кодов</h2>
        
        <LiqSelArr 
          options={events}
          value={selectedEvent}
          onChange={setSelectedEvent}
          className="eventQrControl"
          placeholder="Выберите мероприятие"
          required={true}
          getOptionLabel={(event) => event ? `${event.name} (${event.date})` : ''}
          getOptionValue={(event) => event?._id}
        />

        {selectedEvent && (
          <div className="selected-event-info">
            <h3>Выбрано: {selectedEvent.name}</h3>
            <p>Дата: {selectedEvent.date} | Время: {selectedEvent.time}</p>
          </div>
        )}
        <div className={isEnabled ? "scanerblock" : ""}>
          
          {(selectedEvent && isEnabled) && (
          <div className="selected-event-info">
            <h3>Выбрано: {selectedEvent.name}</h3>
            <p>Дата: {selectedEvent.date} | Время: {selectedEvent.time}</p>
          </div>
        )}
          <div className='' id="qrCodeContainer"></div>
        </div>
        <div className="scanerData">
            
            { selectedEvent ? <div className="botomQRData">
              {(isEnabled && qrMessage) && (
                  <div className='qr-message' key={qrMessage}>
                    {statusScan && <div className={statusScan == "MemberQrScaned" ? "memberData memberDataGreen" : 
                      statusScan == "QrAlreadyScaned"  ? "memberData memberDataOrange" : "memberData memberDataRed"}>
                      <h2>{statusScan == "MemberQrScaned" ? 'Успешно отсканированно' : 
                      statusScan == "QrAlreadyScaned" ? 'Билет уже был использован' : 
                      statusScan == "UserNotExist" || statusScan == "UserNotRegistered" ? 'Пользователь не зареган' : 'Ошибка скана'}</h2>
                      {
                        statusScan == "MemberQrScaned" || statusScan == "QrAlreadyScaned" ? <>
                        <h3>{scanedMemberData?.firstName} {scanedMemberData?.secondName} {scanedMemberData?.thirdName}</h3>
                        {scanedMemberData?.isGrad ? 
                                <h3 className="graduate-badge">Выпускник</h3> : 
                                scanedMemberData && <h3>Класс: {scanedMemberData?.gradeNum} {scanedMemberData?.gradeLetter}</h3>
                        }
                        </> : null
                      }
                      <span className='bottQrData'>{statusScan}</span> 
                      <span className='bottQrData'>{qrMessage}</span> 
                      {/* <h3>{scanedMemberData?.firstName} {scanedMemberData?.secondName} {scanedMemberData?.thirdName}</h3>
                      {scanedMemberData?.isGrad ? 
                              <h3 className="graduate-badge">Выпускник</h3> : 
                              scanedMemberData && <h3>Класс: {scanedMemberData?.gradeNum} {scanedMemberData?.gradeLetter}</h3>
                      } */}
                    </div> }
                  </div>
              )}
                <LiquidButton onClick={() => setEnabled(!isEnabled)}>
                  {isEnabled ? "Завершить сканирование" : "Начать сканирование"}
                </LiquidButton>
              </div> : null}
          </div>
      </div>
    </section>
  );
};

export default QRScan;